import { Button } from '../../components/Button';
import React, { useContext } from 'react';

import { ProfileFormContext } from './context';

/** @type {React.FC} */
export const ButtonToggleRemoveProfile = () => {
    const { sectionData, setRemoveProfileState } =
        useContext(ProfileFormContext);
    const { buttonToggleDeleteProfileLabel } = sectionData;

    return (
        <Button
            variant="danger"
            onClick={() => setRemoveProfileState(true)}
            data-event="profile form (abort remove button)"
        >
            {buttonToggleDeleteProfileLabel}
        </Button>
    );
};
